import BaseSingleton from '../../../base/base_singleton';
import Device from '../../../utils/device/device';

export interface ProductPackageParams {
    webapp: {
        pc: number,
        iphone: number,
        ipad: number,
        other: number,
    }
    native: {
        iphone: number,
        ipad: number,
        other: number,
    }
}

const DEVICE_TYPE = {
    PC: 'pc',
    OTHER: 'other',
    IPHONE_NATIVE: 'iphone',
    IPHONE: 'iphone',
    IPAD_NATIVE: 'ipad',
    IPAD: 'ipad'
};

/**
 */
export default class ProductPackage extends BaseSingleton {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ProductPackage';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    private _params: ProductPackageParams = null;


    /**
     *
     * @param params
     */
    init(params: ProductPackageParams) {
        this._params = params;
    }

    /**
     * Used to detected if user clicked and loaded the app using home screen
     *
     * @returns {boolean} - Returns true if the app is running in standalone mode (iOS only)
     */
    private getDeviceTypeName(): string {

        const hybridTypeByDevice = () => {
            if (Device.model.isIphone) {
                return DEVICE_TYPE.IPHONE_NATIVE;
            } else if (Device.model.isIpad) {
                return DEVICE_TYPE.IPAD_NATIVE;
            }

            return DEVICE_TYPE.OTHER;
        };

        const notHybridTypeByDevice = () => {

            if (Device.model.isIphone) {
                return DEVICE_TYPE.IPHONE;
            } else if (Device.model.isIpad) {
                return DEVICE_TYPE.IPAD;
            } else if (Device.os.isMobileOS) {
                return DEVICE_TYPE.OTHER;
            }

            return DEVICE_TYPE.PC
        };

        if (!Device.hybrid.inCasino) {
            return notHybridTypeByDevice();
        }

        return hybridTypeByDevice();
    }

    /**
     * Getter pkg id
     *
     */
    getProductPackageID(): number {
        const type = this.getDeviceTypeName();

        let packageId = 0;
        if (Device.hybrid.isHybrid) {
            packageId = (this._params.native as any)[type];
        } else {
            packageId = (this._params.webapp as any)[type];
        }
        return packageId;
    }


    /**
     * Get 'pc' key from webapp
     */
    getProductPackageGroupPC(): number[] {
        return [this._params.webapp.pc];
    }


    /**
     * Get all mobile packages id except one for 'pc' key
     */
    getProductPackageGroupMobile(): number[] {
        let filterPackages = (productPackageGroup: ProductPackageParams["webapp"] | ProductPackageParams["native"]) => {
            return Object.keys(productPackageGroup).reduce<number[]>((acc, productPackageKey) => {
                if ('pc' !== productPackageKey) {
                    acc.push(productPackageGroup[productPackageKey]);
                }
                return acc;
            }, []);
        };

        let filteredProductPackage: number[] = [];
        [this._params.webapp, this._params.native].forEach((productPackageGroup) => {
            filteredProductPackage = filteredProductPackage.concat(
                filterPackages(productPackageGroup)
            );
        });
        return filteredProductPackage;
    }
}
